var newsletterBox = {
    init: function() {
        console.log('newsletterBox init');
        $('form[name=newsletter_box]').submit(function (e) {
            e.preventDefault();
            var url = $(this).attr('action');
            var data = $(this).serialize();

            $.ajax({
                url: url,
                data: data,
                method: 'POST',
                dataType: 'json',
                beforeSend: function(){
                    $('#msg').alert('close');
                },
                success: function (msg) {
                    var msgContainer = $('<div class="alert" id="msg">' +
                        '                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>' +
                        '            </div>');
                    if(msg.data.success == false){
                        msgContainer.addClass('alert-danger');
                        msgContainer.append(msg.data.msg);
                        msgContainer.show();
                    }
                    else{
                        msgContainer.addClass('alert-success');
                        msgContainer.append(msg.data.msg);
                        msgContainer.show();
                        $('form[name=newsletter_box]')[0].reset();
                        $('form[name=newsletter_box] .error').removeClass('error');
                    }

                    $('#newsletter-box-text').append(msgContainer);
                }
            })
        });

    }
};